module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "left"
  }, [_c('a', {
    attrs: {
      "href": "#/005toc#acknowledgments"
    }
  }, [_c('span', {
    staticClass: "red-1"
  }, [_vm._v("ACKNOWLEDGMENTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "brown"
  }, [_vm._v("It takes a village to make a book happen: an agent, a publishing team, a photographer, a food stylist, family, friends, testers, and lots of listeners. Thank you all.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("My agent, Judith Weber; editorial director Bill LeBlond; editor Sarah Billingsley; copyeditor Sharon Silva; photographer Susie Cushner; food stylist Carrie Purcell; Doug Ogan, Anne Donnard, Ben Hasman, Peter Perez, David Hawk, and the fabulous team at Chronicle Books.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("My family, who care, support, and encourage me; make me laugh; and are baking partners: my dad, Laura, Michael, Charlie, and Oliver; Kate, Peter, Madison, Max, Sadie, and Kip.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("My supporters and friends, who ate a lot of bread and gave a lot of encouragement: Flo Braker, Sue Chase, Michael Drons, Susan Dunning, Maureen Egan, Carole and Woody Emanuel, Rosalee and Chris Glass, Karen and Michael Good, Kat and Howard Grossman, Faith and David Hague, Helen and Reg Hall, Carolyn and Ted Hoffman, Alice and Norman Klivans, Susan Lasky, Robert Laurence, Rosie Levitan, Gordon Paine, Joan and Graham Phaup, Janet and Alan Roberts, Pam and Stephen Ross, Louise and Erv Shames, Barbara and Max Steinheimer, Kathy Stiefel, Carol Witham, Elaine and Wil Wolfson, and Jeffrey Young.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The brave and thorough testers: Jennifer and Howie Goldsmith (the day before Jennifer gave birth), Howard Grossman, Cheryl Matevish, Taylor Mudge, Dawn Ryan, Allyson Shames, Louise Shames, Kate Steinheimer, and Laura Williams.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9509df22","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/004acknowledgments.vue
// module id = 66
// module chunks = 0